import React from "react";

import "@fortawesome/fontawesome-free/css/all.min.css";

import { IconBrandNextjs } from "@tabler/icons-react";

const About = ({
  about,
  name,
  email,
  number,
  address,
  description,
  pictureURL,
  resumeURL,
  skills,
}) => {
  return (
    <section
      className={about === true ? "about area-bg active" : "about area-bg"}
      id="about"
    >
      <div className="about-me container">
        <div className="main-title">
          <h3>Discover</h3>
          <h2>About Me</h2>
        </div>
        <div className="row">
          <div className="col-md-5 d-block d-lg-none">
            <div className="about-image">
              <img className="img-fluid" src={pictureURL} alt="" />
            </div>
          </div>
          <div className="col-lg-12 col-md-7">
            <div className="about-info">
              <h3>Hello! I am {name},</h3>
              {/* <p>{description}</p> */}
              <p>
                {description.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
              <ul className="personal-info list-unstyled">
                <li className="about-item">
                  <h4>Name</h4>
                  <span>{name}</span>
                </li>
                <li className="about-item">
                  <h4>Phone</h4>
                  <a href={`tel:${number}`}>
                    <span>{number}</span>
                  </a>
                </li>
                <li className="about-item">
                  <h4>Email</h4>
                  <span>
                    <a
                      href={`mailto:${email}`}
                      className="__cf_email__"
                      data-cfemail="a1cbc9cecfe1c8cfc7ced28fc2cecc"
                    >
                      {email}
                    </a>
                  </span>
                </li>
                <li className="about-item">
                  <h4>Address</h4>
                  <span>{address}</span>
                </li>
                <li className="about-item">
                  <h4>Freelance</h4>
                  <span>Available</span>
                </li>
              </ul>
              <div className="my-btn">
                <a
                  href={resumeURL}
                  className="main-btn"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download CV
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="skills container">
        <div className="main-title">
          <h2>My Skills</h2>
        </div>

        <div className="skills-grid">
          <div className="skill-item">
            {/* <i className="fab" style={{ width: 35, height: 40 }}>
              <IconBrandNextjs stroke={2} />
            </i>
             */}
            <IconBrandNextjs stroke={2} marginbottom="10px" fill="#ffcc00" size={50} />
            {/* <i
              className="ti ti-brand-nextjs"
              style={{ marginBottom: "10px" }}
            ></i> */}
            <p>Next.js</p>
          </div>
          {skills.map((skill) => {
            return (
              <div className="skill-item" key={skill.name}>
                <i className={skill.icon}></i>
                <p>{skill.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
